import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-fixtures",
    styleUrls: ["./fixtures.component.scss"],
    templateUrl: "./fixtures.component.html",
    standalone: false
})
export class FUIFixturesComponent {
}
